import axios from 'axios';
import { getCurrentLanguage } from '../utils/languageUtils';

const setupAxiosInterceptors = () => {
  axios.interceptors.request.use(
    (config) => {
      const currentLanguage = getCurrentLanguage();
      
      if (config.method === 'post' || config.method === 'put' || config.method === 'patch') {
        if (config.data && typeof config.data === 'object') {
          if (config.data instanceof FormData) {
            if (!config.data.has('language')) {
              config.data.append('language', currentLanguage);
            }
          } else {
            if (!('language' in config.data)) {
              config.data = { ...config.data, language: currentLanguage };
            }
          }
        } else {
          config.data = { language: currentLanguage };
        }
      } else {
        if (!config.params) {
          config.params = {};
        }
        if (!('language' in config.params)) {
          config.params.language = currentLanguage;
        }
      }
      
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  axios.interceptors.response.use(
    (response) => {
      return response;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
};

export default setupAxiosInterceptors;